import { Download } from "lucide-react";
import { useState } from "react";

const ExportDbDataBtn = () => {
  const [open, setOpen] = useState(false);

  const handleExport = async (year) => {
    try {
  
      const res = await fetch(`https://eskillsbackendportal.onrender.com/api/export-db/${year}?t=${Date.now()}`, {
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      });
  
      const blob = await res.blob();
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `backup_${year}.gz`;
      a.click();
  
      setOpen(false);
    } catch (err) {
      console.error("❌ Export DB failed:", err);
    }
  };
  

  return (
    <div className="relative inline-block">
      {/* Main button */}
      <button
        onClick={() => setOpen(!open)}
         className="bg-[#15A249] text-white rounded-lg hover:bg-green-700 transition-colors flex items-center text-sm p-2"
      >
        <Download className="mr-2 h-4 w-4" />
        Download DB
      </button>

      {/* Dropdown with years */}
      {open && (
        <div className="absolute left-0 mt-2 w-40 bg-white border rounded shadow-lg z-10">
          {Array.from({ length: 5 }, (_, i) => {
            const year = new Date().getFullYear() - i;
            return (
              <button
                key={year}
                onClick={() => handleExport(year)}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                {year}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExportDbDataBtn;
